import {
    jornada,
    JornadaDiariaQueryXor,
    JornadaMensalQueryXor,
} from 'service/api'
import { useDigitacaoColumns } from '../columns'
import { DigitacaoDataGrid } from './DigitacaoDataGrid'
import { useDigitacaoContext } from './useDigitacaoContext'

export default function DigitacaoCentroCustoPage() {
    const { queryParams } = useDigitacaoContext()
    const columns = useDigitacaoColumns()

    const {
        data: mensal,
        isLoading: isLoadingMensal,
        error: mensalError,
    } = jornada.mensal.useFetch({
        queryParams: queryParams as JornadaMensalQueryXor,
        enabled:
            !('dia' in queryParams) &&
            'centroCustoId' in queryParams &&
            !!queryParams.centroCustoId &&
            !!queryParams.funcionarioId,
    })

    const {
        data: diario,
        isLoading: isLoadingDiario,
        error: diarioError,
    } = jornada.diaria.useFetch({
        queryParams: queryParams as JornadaDiariaQueryXor,
        enabled:
            'dia' in queryParams &&
            'centroCustoId' in queryParams &&
            !!queryParams.centroCustoId &&
            !!queryParams.empresaId,
    })

    const errorMensal = (() => {
            if (mensalError) return mensalError
            if (!(queryParams as any).centroCustoId)
                return { message: 'Centro de custo não selecionado' }
            if (!(queryParams as any).funcionarioId)
                return { message: 'Funcionário não selecionado' }
        })(),
        errorDiario = (() => {
            if (diarioError) return diarioError
            if (!(queryParams as any).centroCustoId)
                return { message: 'Centro de custo não selecionado' }
        })()

    return (
        <DigitacaoDataGrid
            columns={columns}
            dataDiario={diario}
            dataMensal={mensal}
            diarioError={errorDiario}
            mensalError={errorMensal}
            isErrorDiario={!!errorDiario}
            isErrorMensal={!!errorMensal}
            isLoadingDiario={isLoadingDiario}
            isLoadingMensal={isLoadingMensal}
        />
    )
}
